document.addEventListener("contextmenu", (event) => {
  if (event.target.closest("img, picture, figure")) {
    event.preventDefault();
  }
});

document.addEventListener("dragstart", (event) => {
  if (event.target.closest("img, picture, figure")) {
    event.preventDefault();
  }
});
